
































import Vue from 'vue';
import { sync } from 'vuex-pathify';
import { authProvider } from '@vue-altoleap-libraries/vue-altoleap-accounts-lib';

export default Vue.extend({
  name: 'AppBar',

  computed: {
    drawer: sync<boolean>('app/drawer'),

    provider(): any {
      return authProvider(this.$store);
    },

    dynamicColor(): string {
      // transparent
      switch (this.$route.name) {
        case 'home':
          return 'transparent';
        default:
          return 'background';
      }
    }
  }
});
